import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { LoginPage } from '@/pages/LoginPage';
import { HomePage } from '@/pages/HomePage';
import { SettingsPage } from '@/pages/SettingsPage';
import { MeetingSetup } from '@/pages/MeetingSetup';
import { LiveSession } from '@/pages/LiveSession';
import { MeetingReview } from '@/pages/MeetingReview';
import { useAuth } from '@/hooks/useAuth';

function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <div className="size-12 rounded-full bg-gradient-to-br from-accent to-cyan animate-pulseSoft" />
    </div>
  );
}

function Protected({ children }: { children: React.ReactNode }) {
  const { state } = useAuth();
  const loc = useLocation();
  if (state.status === 'loading') return <LoadingScreen />;
  if (state.status === 'anon') return <Navigate to="/login" replace state={{ from: loc }} />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Protected><HomePage /></Protected>} />
      <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
      <Route path="/m/new" element={<Protected><MeetingSetup /></Protected>} />
      <Route path="/m/:id/edit" element={<Protected><MeetingSetup /></Protected>} />
      <Route path="/m/:id/live" element={<Protected><LiveSession /></Protected>} />
      <Route path="/m/:id" element={<Protected><MeetingReview /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
